<template>
  <div class="row">
    <div class="col-12">
      <h2 class="h--headingM">Quelle tarification est appliquée ? <span class="asterix">*</span></h2>
      <!-- Info Bloc -->
      <div class="infoBloc mt-4 mb-4" v-if="prestationStore === 'TarifNonDefiniTotal'">
        <div class="infoBloc__icon">
          <inline-svg src="/images/icones/icon_information.svg" />
        </div>
        <p class="infoBloc__text">
          Sélectionnez l'option la plus proche du devis de votre dentiste. En cas de doute, le dispositif 100% Santé correspond aux couronnes sans reste à
          charge.
        </p>
      </div>

      <div class="tarification__blocs" role="group">
        <button
          v-if="prestationStore === 'TarifNonDefiniTotal'"
          type="button"
          class="tarification__bloc stdButton"
          :class="tarificationStore === 'CentPourCent' ? '--active' : ''"
          @click="tarificationChange('CentPourCent')"
        >
          le dispositif 100% Santé
        </button>
        <button
          type="button"
          class="tarification__bloc stdButton"
          :class="tarificationStore === 'TarifMaitrise' ? '--active' : ''"
          @click="tarificationChange('TarifMaitrise')"
        >
          un tarif maîtrisé
        </button>
        <button
          type="button"
          class="tarification__bloc stdButton"
          :class="tarificationStore === 'TarifLibre' ? '--active' : ''"
          @click="tarificationChange('TarifLibre')"
        >
          un tarif libre
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { buildLabel, mapTypePrestation, mapTypeSoin, mapTypeTarification, pushSimulationEvent } from "@/helpers/matomo";

export default {
  name: "EtapeTarification",
  components: {},
  setup() {
    return { v$: useVuelidate() };
  },
  computed: {
    typeDepenseStore() {
      return this.$store.getters["dataSimulateurStore/typeDepense"];
    },
    prestationStore() {
      return this.$store.getters["dataSimulateurStore/prestation"]?.key;
    },
    tarificationStore: {
      get() {
        return this.$store.getters["dataSimulateurStore/tarification"];
      },
      set(value) {
        this.$store.dispatch("dataSimulateurStore/updateTarification", value);
      },
    },
  },
  async mounted() {
    console.debug("Component Tarification is mounted!");
  },
  methods: {
    tarificationChange(index) {
      const typeSoin = mapTypeSoin(this.typeDepenseStore);
      const typePrestation = mapTypePrestation({ key: this.prestationStore });
      const typeTarification = mapTypeTarification(index);

      pushSimulationEvent({
        event: "choix_tarification",
        action: "choix_tarification",
        label: buildLabel({
          typeSoin,
          typePrestation,
          typeTarification,
        }),
        payload: {
          type_tarification: typeTarification,
        },
      });

      this.tarificationStore = index;
    },
  },
};
</script>
